import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import BrandDisplay from '/@/components/brand-display';
import Message from '/@/components/message';
import Title from '/@/components/title';
import { _ } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class BrandSelection extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        brands: PropTypes.array.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    render() {
        const { title, subtitle, brands, onClick } = this.props;
        return (
            <div className={styles.root}>
                <div className={styles.content}>
                    <Title size='xl'>{title}</Title>
                    <Title size='md' color='light'>
                        {subtitle}
                    </Title>
                    <div className={styles.brands}>
                        {brands.map((brand) => (
                            <div key={brand.id}>
                                <BrandDisplay
                                    withTheme
                                    withImage
                                    brand={brand}
                                    onClick={() => onClick(brand.type, brand.slug, brand.name)}
                                />
                            </div>
                        ))}
                    </div>
                    {brands.length === 0 && (
                        <Message type='warning' appearance='fill' showIcon>
                            {_('No hay marcas disponibles.')}
                        </Message>
                    )}
                </div>
            </div>
        );
    }
}
